module.exports = __webpack_public_path__ + "static/media/contact02.120bbb30.png";